import React from 'react';
import {
	Input,
	Select,
	Form,
	Modal,
	DatePicker,
	Upload,
	message,
	Button,
	Icon,
	Col,
	Row,
	Drawer,
	Descriptions,
	Badge,
	Statistic,
	Divider
} from 'antd';
import moment from 'moment';

const DerOrderDetail =(props)=>{

	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (

		<Drawer
			title={item.contract_no ?
				<span>合同号:{item.contract_no}</span> :
				<span>无合同订单</span>}
			placement="right"
			closable={false}
			onClose={onCancel}
			visible={visible}
			width={width}
		>
			<div className="drawer-content">
				<Descriptions title="订单信息" layout="vertical" bordered>
					<Descriptions.Item label="订单总金额">
						<Statistic
							value={item.order_amount / 100}
							precision={2}
							valueStyle={{ fontSize: '15px', fontWeight: 'bold' }}
						/>
					</Descriptions.Item>
					<Descriptions.Item label="保证金金额">
						<Statistic
							value={item.balance_payment_amount / 100}
							precision={2}
							valueStyle={{ fontSize: '15px', fontWeight: 'bold' }}
						/>
					</Descriptions.Item>
					<Descriptions.Item label="融资金额">
						<Statistic
							value={item.credit_payment_amount / 100}
							precision={2}
							valueStyle={{ fontSize: '15px', fontWeight: 'bold' }}
						/>
					</Descriptions.Item>
				</Descriptions>
				<Divider />
				<Descriptions title="一次收款方信息" layout="vertical" bordered>
					<Descriptions.Item label="收款方名称">
						{item.first_payee_info.payeeName}
					</Descriptions.Item>
					<Descriptions.Item label="收款方账号">
						{item.first_payee_info.payeeAccount}
					</Descriptions.Item>
					<Descriptions.Item label="一次受托支付附言">
						{item.first_payee_info.remark}
					</Descriptions.Item>
				</Descriptions>
				<Divider />
				<Descriptions title="最终收款方信息" layout="vertical" bordered>
					<Descriptions.Item label="收款方名称">
						{item.final_payee_list[0].payeeName}
					</Descriptions.Item>
					<Descriptions.Item label="收款方账号">
						{item.final_payee_list[0].payeeAccount}
					</Descriptions.Item>
					<Descriptions.Item label="收款方开户行名称">
						{item.final_payee_list[0].payeeBankName}
					</Descriptions.Item>
					<Descriptions.Item label="收款方开户行行号">
						{item.final_payee_list[0].payeeBankCode}
					</Descriptions.Item>
					<Descriptions.Item label="收款金额">
						{(item.final_payee_list[0].collectedAmount)/100}
					</Descriptions.Item>
					<Descriptions.Item label="附言">
						{item.final_payee_list[0].postscript}
					</Descriptions.Item>
				</Descriptions>
				<Divider />
				<Descriptions title="商品信息" layout="vertical" bordered>
					{item.product_info_list.map((product, index) => (
						<Descriptions.Item key={index} label={`商品 ${index + 1}`}>
							<p>商品名称: {product.goodsName}</p>
							<p>商品价格: {product.goodsPrice}</p>
							<p>一级分类: {product.levelOneName}</p>
							<p>二级分类: {product.levelTwoName}</p>
							<p>三级分类: {product.levelThreeName}</p>
							<p>材质: {product.goodsAttributeList.find((attr) => attr.attributeName === '材质')?.attributeValue}</p>
							<p>规格: {product.goodsAttributeList.find((attr) => attr.attributeName === '规格')?.attributeValue}</p>
							<p>产地: {product.goodsAttributeList.find((attr) => attr.attributeName === '产地')?.attributeValue}</p>
							<p>数量: {product.goodsMeasurementOne} {product.goodsMeasurementOneUnit}</p>
						</Descriptions.Item>
					))}
				</Descriptions>
			</div>
		</Drawer>


	)

}


export default DerOrderDetail;
